import {
  extendADNDDataSource,
  DEFAULT_PROPS as ADNDDataSource_DEFAULT_PROPS,
  PRIVATE as ADNDDataSource_PRIVATE
} from '../ADNDDataSource'
import { getScrollX, getScrollY, isCloningEvent } from '../../ADNDHelpers'
import ADND from '../../ADND'
import { updateState } from '../../ADNDState'
import ADNDDragLayer from '../../layers/ADNDDragLayer'
import ADNDTargetsLayer from '../../layers/ADNDTargetsLayer'

function DEFAULT_PROPS() {
  return {
    ...ADNDDataSource_DEFAULT_PROPS(),
    item: null,
    dragLayer: null,
    moveable: true,
    cloneable: true,
    cloneNoteBuilder: null,
    lockX: true,
    lockY: false,
    hitShift: true
  }
}

const PRIVATE = {
  doStart(event) {
    if (null == this.props.dragLayer) {
      const itemNode = null != this.props.item ? this.props.item.connectedNode() : null
      if (null != itemNode) {
        const cursorX = event.pageX || event.clientX
        const cursorY = event.pageY || event.clientY

        this.props.dragLayer = ADNDDragLayer()
        this.props.dragLayer.start(event)
        if (this.props.cloneable && this.props.cloneNoteBuilder) {
          const { cloningNode, movingNode } = this.props.cloneNoteBuilder() || {}
          if (null != cloningNode && null != movingNode) {
            this.props.dragLayer.useCloneNote({ cloningNode, movingNode })
          }
        }
        this.props.dragLayer.cloneContent({
          cursorX,
          cursorY,
          node: itemNode,
          lockX: this.props.lockX,
          lockY: this.props.lockY,
          className: this.props.item.getDragLayerClassName(),
          finalizeContent: this.props.item.doFinalizeDragLayerContent
        })
        ADND().addLayer(this.props.dragLayer)

        if (this.props.lockX) {
          ADNDTargetsLayer().lockX(cursorX)
        }
        if (this.props.lockY) {
          ADNDTargetsLayer().lockY(cursorY)
        }

        if (false !== this.props.hitShift) {
          if (true === this.props.hitShift && this.props.rect && null != this.props.rect.top) {
            ADNDTargetsLayer().hitShift(0, this.props.rect.top - cursorY)
          } else if ('object' === typeof this.props.hitShift) {
            ADNDTargetsLayer().hitShift(this.props.hitShift.x, this.props.hitShift.y)
          }
        }

        if (this.props.cloneable && isCloningEvent(event)) {
          updateState(state => {
            state.operation.type = 'clone'
            state.operation.enableMove = this.props.moveable
            state.operation.enableClone = this.props.cloneable
            return state
          })
        } else {
          this.PRIVATE.doHide()
          updateState(state => {
            state.operation.type = 'move'
            state.operation.enableMove = this.props.moveable
            state.operation.enableClone = this.props.cloneable
            return state
          })
        }

        if (event.dataTransfer) {
          event.dataTransfer.effectAllowed = 'copyMove'
        }
      }
    }
    return ADNDDataSource_PRIVATE.doStart.call(this, event)
  },
  doEnd(event) {
    ADNDTargetsLayer().hitShift(0, 0)
    if (null != this.props.dragLayer) {
      this.props.dragLayer.stop(event)
      ADND().removeLayer(this.props.dragLayer)
      this.props.dragLayer = null
    }
    this.PRIVATE.doShow()
    return ADNDDataSource_PRIVATE.doEnd.call(this, event)
  },
  fetchRect(scrollX = getScrollX(), scrollY = getScrollY()) {
    if (null != this.props.item) {
      const itemNode = this.props.item.connectedNode()
      if (null != itemNode) {
        const rect = itemNode.getBoundingClientRect()
        this.props.rect = {
          left: rect.left + scrollX,
          right: rect.right + scrollX,
          top: rect.top + scrollY,
          bottom: rect.bottom + scrollY,
          width: rect.width || rect.right - rect.left,
          height: rect.height || rect.bottom - rect.top
        }
      } else {
        this.props.rect = null
      }
    } else {
      this.props.rect = null
    }
    return this.PRIVATE
  },
  doHide() {
    if (null != this.props.item) {
      this.props.item.doHide()
    }
    return this.PRIVATE
  },
  doShow() {
    if (null != this.props.item) {
      this.props.item.doShow()
    }
    return this.PRIVATE
  },
  isHidden() {
    return null != this.props.item ? this.props.item.isHidden() : false
  },
  updateOperationType(operationType) {
    switch (operationType) {
      case 'clone':
        this.PRIVATE.doShow()
        break
      case 'move':
        this.PRIVATE.doHide()
        break
      default:
        break
    }
    return this.PRIVATE
  },
  getDropEffect(operationType) {
    return 'move' == operationType ? 'move' : 'copy'
  }
}

const PUBLIC = {
  buildCloneNote(cloneNoteBuilder) {
    if ('function' == typeof cloneNoteBuilder) {
      this.props.cloneNoteBuilder = cloneNoteBuilder
    }
    return this.PUBLIC
  }
}

export default function ADNDListItemHandle(props = {}) {
  const ADNDListItemHandle = extendADNDDataSource(props, DEFAULT_PROPS())

  ADNDListItemHandle.PRIVATE.doStart = PRIVATE.doStart.bind(ADNDListItemHandle)
  ADNDListItemHandle.PRIVATE.doEnd = PRIVATE.doEnd.bind(ADNDListItemHandle)
  ADNDListItemHandle.PRIVATE.fetchRect = PRIVATE.fetchRect.bind(ADNDListItemHandle)
  ADNDListItemHandle.PRIVATE.doHide = PRIVATE.doHide.bind(ADNDListItemHandle)
  ADNDListItemHandle.PRIVATE.doShow = PRIVATE.doShow.bind(ADNDListItemHandle)
  ADNDListItemHandle.PRIVATE.isHidden = PRIVATE.isHidden.bind(ADNDListItemHandle)
  ADNDListItemHandle.PRIVATE.updateOperationType = PRIVATE.updateOperationType.bind(ADNDListItemHandle)
  ADNDListItemHandle.PRIVATE.getDropEffect = PRIVATE.getDropEffect.bind(ADNDListItemHandle)

  ADNDListItemHandle.PUBLIC.buildCloneNote = PUBLIC.buildCloneNote.bind(ADNDListItemHandle)

  return ADNDListItemHandle.PUBLIC
}
